export default {
    characters: null
}